import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './DirectoryTree.css';

const DirectoryTree = ({ directories, onSelect, currentPath, mediaType }) => {
  //console.log("### DirTree " + directories);
  if (directories != null)
    return (
      <div className="directory-tree">
        <ul>
          {directories.map(dir => (
            <DirectoryItem key={dir.id} directory={dir} onSelect={onSelect} currentPath={currentPath} mediaType={mediaType} />
          ))}
        </ul>
      </div>
    );
};

//  Recursive component to handle nested directories (if you have them)
const DirectoryItem = ({ directory, onSelect, currentPath, mediaType }) => {
  const isParent = currentPath && currentPath.startsWith(directory.path);

  // State to manage whether this directory is expanded or collapsed. Start
  // as collapsed unless showing a page under this directory.
  const [isExpanded, setIsExpanded] = useState(isParent);

  // Check if the current directory is the one selected
  const isActive = currentPath === directory.path;

  // Toggle expand/collapse state
  const handleToggleExpand = (e) => {
    e.stopPropagation(); // Prevent directory selection when toggling arrow
    setIsExpanded(!isExpanded);
  };

  const navigate = useNavigate();

  // Handle directory selection (clicking the name)
  const handleDirectoryClick = () => {
    onSelect(directory.path);
    // Optionally, expand the folder when it's selected, unless it's a leaf node
    if (directory.children && directory.children.length > 0) {
      setIsExpanded(true);
    }
    // Change browser URL
    const url = "/" + mediaType + "/" + encodeURIComponent(directory.path);
    navigate(url, { replace: false });
  };

  return (
    <li className={`directory-item ${isActive ? 'active' : ''}`}>
      <div className="directory-header">
        {directory.children && directory.children.length > 0 && (
          <span
            className={`toggle-icon ${isExpanded ? 'expanded' : ''}`}
            onClick={handleToggleExpand}
          >
            {/* You can use a real icon font (FontAwesome, Material Icons) or SVG here */}
            {isExpanded ? '▼' : '►'}
          </span>
        )}
        <button
          //onClick={() => window.location.href = url} 
          onClick={handleDirectoryClick}
          className={`directory-name-button ${isActive ? 'active' : ''}`}
        >
          {directory.name}
        </button>
      </div>
      {isExpanded && directory.children && directory.children.length > 0 &&
        <DirectoryTree directories={directory.children} onSelect={onSelect} currentPath={currentPath} mediaType={mediaType} />
      }
    </li>
  );
};

export default DirectoryTree;